import { IButton } from '@/types/shared';

export const REGISTER_FORM_TITLE = 'ព័ត៌មានទំនាក់ទំនង';
export const THANK_YOU_TITLE = 'សូមអរគុណចំពោះព័ត៌មានរបស់អ្នក';
export const THANK_YOU_DESCRIPTION =
  'យើងបានទទួលព័ត៌មានចុះឈ្មោះរបស់អ្នក ហើយនឹងទាក់ទងអ្នកក្នុងពេលឆាប់ៗនេះ';

export const THANKYOU_BUTTON: IButton = {
  label: 'មើលពត៌មានបន្ថែម',
  url: '/',
  icon: 'home',
};
